import * as React from 'react';
import { Field, Input, Paragraph, Button } from '@quickmd-llc/design-system';
import { useApplicationStore } from '@data';
import { PATIENT_WEB_LOCAL_DEV_SERVER_URL } from 'data/slices/devTools';
import { useAutoUpdatingRef } from '@quickmd-llc/frontend-utils';

function isValidUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

// eslint-disable-next-line regex/invalid-error
const deployedPatientWebUrl = import.meta.env.VITE_DOCTOR_VISIT_URL;

export function PatientWebUrlSection() {
  const {
    setPatientWebUrl,
    isLocalPatientWeb,
    isDeployedPatientWeb,
    patientWebUrl,
  } = useApplicationStore().devTools;

  const cleanupDataRef = useAutoUpdatingRef({
    setPatientWebUrl,
    isLocalPatientWeb,
    isDeployedPatientWeb,
    patientWebUrl,
  });

  React.useEffect(() => {
    const cleanupData = cleanupDataRef.current;
    return () => {
      if (!cleanupData.isLocalPatientWeb && !cleanupData.isDeployedPatientWeb) {
        const urlOnClose = isValidUrl(cleanupData.patientWebUrl)
          ? cleanupData.patientWebUrl
          : deployedPatientWebUrl;

        cleanupData.setPatientWebUrl(urlOnClose);
      }
    };
  }, [cleanupDataRef]);

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        Patient Web URL
      </Paragraph>

      <div className="mb-2">
        <Field>
          <Input
            value={patientWebUrl}
            onChange={(e) => setPatientWebUrl(e.target.value.trim())}
            type="text"
            placeholder="Current Patient Web URL"
          />
        </Field>
      </div>

      <div className="flex gap-2">
        {Array.from({ length: 2 }, (_, i) => {
          const isLocal = !i;
          const isActive = isLocal ? isLocalPatientWeb : isDeployedPatientWeb;
          const action = () => {
            const nextUrl = isLocal
              ? PATIENT_WEB_LOCAL_DEV_SERVER_URL
              : deployedPatientWebUrl;
            setPatientWebUrl(nextUrl);
          };

          return (
            <Button
              key={i}
              priority={isActive ? 'primary' : 'secondary'}
              size="s"
              onClick={action}
              type="button"
            >
              {isLocal ? 'Local' : 'Deployed'} Patient Web
            </Button>
          );
        })}
      </div>
    </div>
  );
}
